import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20" id="how-it-works">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="lg:w-1/2 w-full animate-in">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20setup%20with%20open%20laptop%20displaying%20colorful%20product%20spreadsheet%20next%20to%20a%20ceramic%20coffee%20cup%20and%20small%20potted%20plant%20warm%20cream%20wall%20background%20soft%20natural%20window%20light%20creating%20gentle%20highlights%20editorial%20photography%20calm%20organized%20atmosphere%20with%20plenty%20of%20breathing%20room&width=800&height=600&seq=itaobuy-about-workspace-v4&orientation=landscape"
                alt="Itaobuy spreadsheet workspace with curated product catalog"
                title="How the Itaobuy Spreadsheet System Works"
                className="w-full h-auto object-cover"
              />
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1.5 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium backdrop-blur-sm">
                  Trending Now
                </span>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-1/2 w-full animate-in animate-in-delay-2">
            <p className="text-xs text-foreground-500 uppercase tracking-widest mb-3">About the System</p>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6 leading-snug">
              What is the Itaobuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
              <p>
                The <strong className="text-foreground-950">itaobuy spreadsheet</strong> is a structured product listing system that organizes China sourcing products into categorized, filterable spreadsheets. Instead of browsing endless marketplaces, users can filter products instantly, compare prices easily, and access agent-based shopping links — all from one clean interface.
              </p>
              <p>
                It simplifies cross-border shopping from China platforms like Taobao and 1688 by removing the guesswork. Every product entry includes verified supplier data, shipping guidance, and direct links — so even first-time buyers can shop with confidence.
              </p>
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-2 gap-2 mt-6">
              {["Faster product discovery", "Lower shopping risk", "Organized supplier data", "Easy comparison across categories", "Beginner-friendly structure", "Agent-ready shopping links"].map((benefit) => (
                <div key={benefit} className="flex items-start gap-2 text-sm text-foreground-600">
                  <span className="w-4 h-4 flex items-center justify-center mt-0.5 text-accent-500 shrink-0">
                    <i className="ri-check-line text-xs" />
                  </span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <Link
              to="/article/itaobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Full SEO Guide
              <i className="ri-arrow-right-line text-xs" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}